import { render, staticRenderFns } from "./DoctorRegisterOperateForm.vue?vue&type=template&id=4a841b4c&"
import script from "./DoctorRegisterOperateForm.vue?vue&type=script&lang=js&"
export * from "./DoctorRegisterOperateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports